import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  Router,
  ActivatedRoute,
} from '@angular/router';
import { StoreDetailService } from '../../services/resolver/store-detail.service';
import { LocalStorageService } from '../../services/storage/local-storage.service';
import { StateService } from '../../services/storage/state.service';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Language } from '../../enum/Language';
import { environment } from 'src/environments/environment';
import { StoreDetail } from '../../models/store-details.model';
import { CountryDetail, Profile } from '../../models/profile.mode';
import { LogoutDialogComponent } from 'src/app/modules/product/components/logout-dialog/logout-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StoreRegionService } from '../../services/store-region.service';
import { GoogleTagManagerService } from '../../services/google-tag-manager.service';
import { PanelService } from '../../services/api/panel.service';
import { SnackBarService } from '../../services/snack-bar.service';
import { StoreCountry } from '../../models/store-country.model';
import { RegionUrlService } from '../../services/region-url.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  host: {
    '(document:click)': 'onClick($event)',
  },
})
export class NavigationComponent implements OnInit, AfterViewInit {
  storeDetail: StoreDetail;
  selectedLang: String = 'En';
  isLoggedIn: boolean = false;
  isShowOptions: boolean = false;
  storeRegionSelect: FormControl<StoreCountry> = new FormControl();
  languageControl: FormControl = new FormControl();
  currencyControl: FormControl = new FormControl();
  languageImage: any = '';
  languageCode: any = ''
  showBalance: boolean = false;
  remaining: any;
  isProfileOption: boolean = false;
  profileData: Profile;
  params: any;
  countryList: StoreCountry[];
  filteredCountryList: StoreCountry[];
  searchedCountry = '';
  selectedRegion: StoreCountry;
  countryIdParam: string;
  prefrencesDialogRef: MatDialogRef<any>;

  availableLanguages = [
    {
      code: 'en',
      str: 'English',
      img: 'assets/images/icons/usa-flag.svg',
      primaryImage: 'assets/images/icons/usa-primary-flag.png',
    },
    {
      code: 'ar',
      str: 'العربية',
      img: 'assets/images/icons/uae-flag.svg',
      primaryImage: 'assets/images/icons/uae-primary-flag.png',
    },
    {
      code: 'tr',
      str: 'Türkçe',
      img: 'assets/images/icons/turkey-flag.svg',
      primaryImage: 'assets/images/icons/turkey.png',
    },
    // {
    //   code: 'fa',
    //   str: 'Fa',
    //   img: 'assets/images/icons/iran.svg',
    //   primaryImage: 'assets/images/icons/iran.png'
    // }
  ];

  @ViewChild('mobileMenu') mobileMenu: ElementRef;
  @ViewChild('mobileOverlay') mobileOverlay: ElementRef;
  @ViewChild('prefrencesDialog') prefrencesDialog: any;
  platformId: Object

  kingVersion:boolean=false

  constructor(
    private renderer: Renderer2,
    private router: Router,
    private stateService: StateService,
    private storeDetailResolver: StoreDetailService,
    private localStorageService: LocalStorageService,
    private translateService: TranslateService,
    private _eref: ElementRef,
    private storeRegionService: StoreRegionService,
    @Inject(DOCUMENT) private document: Document,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) platformId: Object,
    private googleTagManagerService: GoogleTagManagerService,
    private panelService: PanelService,
    private snackBarService: SnackBarService,
    public regionUrl: RegionUrlService,
  ) { 
    this.platformId = platformId
  }

  ngOnInit(): void {
    if(this.isClientPlatform(this.platformId)) {
      if(window['__NEZHA_BRIDGE__']){
        this.kingVersion=true
      }
    }
    this.activatedRoute.queryParams.subscribe(param => {
      this.countryIdParam = param.country || '';
    })
    this.checkUserLanguage();
    this.setLoginStatus();
    this.getStoreDetail();
    this.initRegion();
    this.handleRegionChange();
  }
  
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.checkIsFirstVisit();
    }, 7000);
  }

  filterCountries() {
    const searchTextLower = this.searchedCountry.toLowerCase();
    this.filteredCountryList = this.countryList.filter(country =>
      country.name.toLowerCase().includes(searchTextLower)
    );
  }

  clearSearchField() {
    this.searchedCountry = '';
    this.filteredCountryList = this.countryList;
  }

  onClick(event) {
    if (!this._eref.nativeElement.contains(event.target)) {
      this.isShowOptions = false;
      this.showBalance = false;
      this.isProfileOption = false;
    }
  }

  checkUserLanguage() {
    let userLang;
    if(this.isClientPlatform(this.platformId)) {
      userLang = this.localStorageService.getItem('userLang');
    }

    if (userLang) {
      this.changeLanguage(userLang, true);
    } else {
      this.changeLanguage(environment.defaultLang, true);
    }
  }

  changeLanguage(lang: any, isInitial?: boolean) {
    if(!isInitial) {
      this.googleTagManagerService.sendAnalytics('change_language', {
        from: this.stateService.userLanguage.value,
        to: lang
      });     
    }
    let languageObject = this.availableLanguages.find(
      (obj) => obj?.code === lang
    );
    this.languageControl.patchValue(languageObject)
    this.languageImage = languageObject.primaryImage;
    this.languageCode = languageObject.str
      if(this.isClientPlatform(this.platformId)) {
        this.localStorageService.setItem('userLang', lang);
      }
    this.stateService.setLanguageStatus(lang);
    this.selectedLang = Language[lang];
    let htmlTag = this.document.getElementsByTagName(
      'html'
    )[0] as HTMLHtmlElement;
    if (lang === 'fa' || lang == 'ar') {
      htmlTag.dir = 'rtl';
    } else {
      htmlTag.dir = 'ltr';
    }
    this.changeCssFile(lang);
    this.translateService.setDefaultLang(lang);
    this.translateService.use(lang);
    this.closeMenu();
  }

  openOptions(option: string) {
    if (option == 'wallet') {
      this.showBalance = !this.showBalance;
      this.isShowOptions = false;
      this.isProfileOption = false;
    } else if (option == 'language') {
      this.isShowOptions = !this.isShowOptions;
      this.showBalance = false;
      this.isProfileOption = false;
    } else if (option == 'profile') {
      this.isProfileOption = !this.isProfileOption;
      this.isShowOptions = false;
      this.showBalance = false;
    }
  }

  changeCssFile(lang: string) {
    let headTag = this.document.getElementsByTagName(
      'head'
    )[0] as HTMLHeadElement;
    let bundleName;
    if (lang === 'fa' || lang == 'ar') {
      bundleName = './arabicStyle.css';
    } else {
      bundleName = './englishStyle.css';
    }
    let existingLink = this.document.getElementById(
      'langCss'
    ) as HTMLLinkElement;
    if (existingLink) {
      existingLink.href = bundleName;
    } else {
      let newLink = this.document.createElement('link');
      newLink.rel = 'stylesheet';
      newLink.type = 'text/css';
      newLink.id = 'langCss';
      newLink.href = bundleName;
      headTag.appendChild(newLink);
    }
  }

  setLoginStatus() {
    this.stateService.setLoginStatus(this.isClientPlatform(this.platformId) ? this.localStorageService.isLoggedIn : false);
    let subscription = this.stateService
      .getLoginStatus()
      .subscribe((isLoggedIn) => {
        // if (isLoggedIn) {
        //   // this.getWalletBalance();
        //   this.getProfileData();
        // }
        this.isLoggedIn = isLoggedIn;
      });
    // subscription.unsubscribe();
  }

  getStoreDetail() {
    this.storeDetail = this.storeDetailResolver.permissionInit;
    this.initCurrencyControl();
  }

  // getStoreGroup() {
  //   this.storeGroups = this.storeGroupResolver.permissionInit?.stores_detail;
  // }

  initRegion() {
  let countries = this.storeRegionService.countryList;
  const priorityOrder = ['GLC', 'US', 'AE']; 
  countries.sort((a, b) => {

    const indexA = priorityOrder.indexOf(a.code);
    const indexB = priorityOrder.indexOf(b.code);

    if (indexA !== -1 && indexB === -1) {
      return -1;
    }
    if (indexA === -1 && indexB !== -1) {
      return 1;
    }
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
    return 0;
  });

  this.countryList = countries;
  this.filteredCountryList = this.countryList;

  const defaultRegion = this.filteredCountryList.find(country => country.is_country_of_request == true);
  this.selectedRegion = this.storeRegionService.selectedRegion ? this.storeRegionService.selectedRegion : defaultRegion;
  if (!this.selectedRegion) {
    return;
  }
  this.storeRegionSelect.patchValue(
    this.filteredCountryList.find(item => item.id === this.selectedRegion.id),
    { emitEvent: false }
  );
}

  // getWalletBalance() {
  //   this.walletBalance.permissionInitInfo.subscribe((data) => {
  //     this.remaining = data;
  //   });
  // }

  // getProfileData() {
  //   this.profileResolver.permissionInitInfo.subscribe((data) => {
  //     this.profileData = data;
  //   });
  // }

  openMenu() {
    this.renderer.addClass(
      this.mobileMenu?.nativeElement,
      'active-mobile-menu'
    );
    this.renderer.addClass(
      this.mobileOverlay.nativeElement,
      'active-mobile-menu'
    );
  }


  openPrefrences() {
    this.prefrencesDialogRef = this.dialog.open(this.prefrencesDialog)
  }

  savePrefrences() {
  this.changeLanguage(this.languageControl.value.code);
  this.setUserCurrency(this.currencyControl.value);

  const changedRegion = this.selectedRegion?.id !== this.storeRegionSelect.value.id;
  if (changedRegion) {
    this.googleTagManagerService.sendAnalytics('change_region', {
      from: this.selectedRegion.code,
      to: this.storeRegionSelect.value.code
    });

    this.storeRegionService.setRegion(this.storeRegionSelect.value);

    const region = this.storeRegionSelect.value as StoreCountry | null;
    const code = (region?.code ?? 'US').toString().slice(0, 2).toLowerCase();

    this.regionUrl.navigateWithCode(code);

    this.selectedRegion = this.storeRegionSelect.value;
  }

  this.prefrencesDialogRef.close();

}

  closeMenu() {
    if (this.mobileMenu) {
      this.renderer.removeClass(
        this.mobileMenu.nativeElement,
        'active-mobile-menu'
      );
    }
    if (this.mobileOverlay) {
      this.renderer.removeClass(
        this.mobileOverlay.nativeElement,
        'active-mobile-menu'
      );
    }
  }

  logOutUser() {
    this.closeMenu();
    this.dialog.open(LogoutDialogComponent);
  }


setUserCurrency(currency: any) {
  const userCurrency = this.localStorageService.getItem('userCurrency');

  if (userCurrency?.id === currency.id) {
    return;
  }

  this.localStorageService.setItem('userCurrency', currency);

  if (this.localStorageService.isLoggedIn) {
    this.panelService.changeCurrency(currency.code).subscribe({
      next: (res) => {
        this.snackBarService.showSnackBar(res.detail, 'primary', 2000);
        window.location.reload();
      },
      error: () => {
        window.location.reload();
      }
    });
  } else {
    window.location.reload();
  }
}

  isClientPlatform(platformId: Object) {
    if(isPlatformBrowser(platformId)) {
      return true
    } else return false
  }

  initCurrencyControl() {
    const initialCurrency = this.localStorageService.getItem('userCurrency');
    if(initialCurrency) this.currencyControl.patchValue(this.storeDetail.supported_currencies_detail.find(cur => cur.id == initialCurrency.id)) 
  }

  checkIsFirstVisit() {
    const isVisited = !!this.localStorageService.getItem('isVisited');
    if(!isVisited) {
      this.openPrefrences();
      this.localStorageService.setItem('isVisited', true);
    }
  }

 handleRegionChange() {
    const setCurrency = (country: any) => {
      if (country && this.storeDetail?.supported_currencies_detail) {
        if (country.code === 'AE') {
          const aedCurrency = this.storeDetail.supported_currencies_detail.find(
            (c: any) => c.code === 'AED'
          );
          if (aedCurrency) this.currencyControl.setValue(aedCurrency);
        } else if (country.code === 'US') {
           const usdCurrency = this.storeDetail.supported_currencies_detail.find(
            (c: any) => c.code === 'USD'
          );
          if (usdCurrency) this.currencyControl.setValue(usdCurrency);
        }
      }
    };
    this.storeRegionSelect.valueChanges.subscribe((country) => setCurrency(country));
  }
}
